import { isGovernmentOfferType } from '@phx/data-sources/medication-marketplace';

import {
    useFillPathway,
    useFillPrescription,
} from '../../../../contexts/fill/use-fill-prescription';
import {
    filterOffersBySubPathway,
    type PrescriptionOffer,
} from '../../../../hooks/use-prescription-offers';
import type { PricingCardProps } from '../common/shared';

export type UseGovernmentPricing = {
    patientPay: number | null;
    priceType: PrescriptionOffer['headlinePriceType'];
};

export const useGovernmentPricing = (
    offer: PricingCardProps['offer']
): UseGovernmentPricing => {
    const { allOffers } = useFillPrescription();
    const { subPathway } = useFillPathway();

    const governmentOffers = allOffers.filter((offer) =>
        isGovernmentOfferType(offer.headlinePriceType)
    );
    const subPathwayOffers = filterOffersBySubPathway(
        governmentOffers,
        subPathway
    );

    const bridgeOffer = subPathwayOffers.find(
        (o) => o.headlinePriceType === 'MedicareBridge'
    );

    if ((offer?.patientCost ?? -1) >= 0) {
        return {
            patientPay: offer!.patientCost,
            priceType: offer!.headlinePriceType,
        };
    }

    if ((bridgeOffer?.patientCost ?? -1) >= 0) {
        return {
            patientPay: bridgeOffer!.patientCost,
            priceType: bridgeOffer!.headlinePriceType,
        };
    }

    return { patientPay: null, priceType: null };
};
